import SelectCollectPoint from "../modules/SelectCollectPoint";
import SelectContactAddress from "../modules/SelectContactAddress";

export default {
  init() {
    $(document).on("change", "#schedule_tabs_dates input", function () {
      const target = $(this).data("time-id");
      $(`#schedule_tabs_times .schedule_tab_time`)
        .find("input")
        .attr("checked", false);
      $(`#schedule_tabs_times .schedule_tab_time`).removeClass("active");
      $(
        `#schedule_tabs_times .schedule_tab_time[data-date-id="${target}"]`
      ).addClass("active");
    });

    $('#local-delivery-address input[type="radio"]').on("change", function () {
      const url = $("#local-delivery-address").data("render");
      const zipcode = $(this).data("zipcode");
      const address = $(this).data("address");
      const notvalid= $(this).data("notvalid");

      $("#delivery-date-choice").load(
        `${url}&notvalid=${notvalid}&zipcode=${zipcode}&address=${address} #delivery-date-choice-content`
      );
    });

    $('#local-delivery-address input[type="radio"]:checked')
      .first()
      .trigger("change");
    SelectCollectPoint();
    SelectContactAddress();
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./assets/src/js/routes/delivery.js